var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Multiselect',_vm._b({class:{
    'scrollable': _vm.options.length > 7,
  },attrs:{"multiple":true,"options":_vm.options,"taggable":true,"label":_vm.label,"track-by":_vm.trackBy,"custom-label":_vm.customLabel,"loading":_vm.isLoading,"internal-search":false,"disabled":_vm.disabled},on:{"search-change":_vm.search,"tag":_vm.tryToAddTag},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}},'Multiselect',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }